
import api from "../utils/api";

const BASE = "/api/authentication/users";

export const getUsers = async (params = {}) => (await api.get(BASE, { params })).data;
export const getUser = async (id) => (await api.get(`${BASE}/${id}`)).data;
export const createUser = async (payload) => (await api.post(BASE, payload)).data;
export const updateUser = async (id, payload) => (await api.put(`${BASE}/${id}`, payload)).data;
export const deleteUser = async (id) => (await api.delete(`${BASE}/${id}`)).data;
export const resetUserPassword = async (id, payload) =>
  (await api.put(`${BASE}/${id}/reset-password`, payload)).data;
export const assignUserRole = async (id, roleId) =>
  (await api.post(`${BASE}/${id}/assign-role`, { role_id: roleId })).data;
export const unassignUserRole = async (id) =>
  (await api.post(`${BASE}/${id}/unassign-role`)).data;
export const assignUserShops = async (id, shopIds = []) =>
  (await api.post(`${BASE}/${id}/assign-shops`, { shop_ids: shopIds })).data;
export const unassignUserShops = async (id, shopIds = []) =>
  (await api.post(`${BASE}/${id}/unassign-shops`, { shop_ids: shopIds })).data;
